import React from "react";
import { useSelector } from "react-redux";
import CpDbHOC from "@components/HOC/CpDbHOC";
import PacketCardV3 from "./PacketCardV3";
import OrderItemCard from "./OrderItemCard";

interface ShipmentCardProps {
  item: {
    product_image: string;
    name: string;
    original_quantity: number;
  };
  showIssueBtn?: boolean;
  navigation: any;
  isCpDb: boolean;
  isOfdCp: boolean;
  source?: string;
}

const ShipmentCard = (props: ShipmentCardProps) => {
  const { partialDeliveryEnabled = false } = useSelector(
    ({ configReducer }: any) => configReducer,
  );

  if (partialDeliveryEnabled && props.source === "PRE_DELIVERY") {
    return <OrderItemCard {...props} />;
  }
  return <PacketCardV3 {...props} />;
};

export default CpDbHOC(ShipmentCard);
